import { useAuthStore } from '@/features/auth/store/auth-store';
import { Shield, LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { AVISO_SOLO_MIRA, useSoporteSoloMira } from '@/features/mini-prixia/soporte-solo-mira';

export function SupportModeBanner() {
  const { isImpersonating, user, exitImpersonation } = useAuthStore();
  // En una empresa demo soporte sólo mira: un botón apagado no muestra su ayuda con el mouse,
  // así que el aviso va fijo y a la vista.
  const soloMira = useSoporteSoloMira();

  if (!isImpersonating || !user) return null;

  const handleExit = () => {
    exitImpersonation();
    /*
      Recarga completa, igual que al entrar y por lo mismo: al salir estamos
      parados adentro del portal de la persona impersonada, así que el router
      corre con `basename=/<slug>` y `navigate('/plataforma/empresas')`
      terminaría en `/<slug>/plataforma/empresas` — el panel montado adentro de
      una empresa, que es exactamente lo que este frente vino a deshacer.
    */
    window.location.href = '/plataforma/empresas';
  };

  return (
    <div className="bg-violet-600 px-4 py-2 flex items-center justify-between text-sm text-white">
      <div>
        <div className="flex items-center gap-2">
          <Shield className="h-4 w-4" />
          <span>
            <strong>Modo Soporte</strong> — Viendo como{' '}
            <strong>
              {user.firstName} {user.lastName}
            </strong>{' '}
            ({user.email}){user.tenant && <> — {user.tenant.name}</>}
          </span>
        </div>
        {soloMira && (
          <p role="status" className="pl-6 text-xs text-white/90">
            {AVISO_SOLO_MIRA}
          </p>
        )}
      </div>
      <Button
        variant="secondary"
        size="sm"
        className="h-7 text-xs bg-white/20 hover:bg-white/30 text-white border-0"
        onClick={handleExit}
      >
        <LogOut className="h-3 w-3 mr-1" />
        Volver a mi cuenta
      </Button>
    </div>
  );
}
